__turbopack_context__.v({
  "content": "_1UW1DG_content",
  "contentContainer": "_1UW1DG_contentContainer",
  "iconContainer": "_1UW1DG_iconContainer",
  "infoBox": "_1UW1DG_infoBox",
  "note": "_1UW1DG_note",
  "tip": "_1UW1DG_tip",
  "title": "_1UW1DG_title",
  "warning": "_1UW1DG_warning",
});
